import { Boxes, MonitorSmartphone, Smartphone } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const SOLUTIONS = [
  {
    icon: MonitorSmartphone,
    title: "Responsive Web Application",
    description:
      "Launch your product as a responsive web application that works across desktop, tablet and mobile.",
  },
  {
    icon: Smartphone,
    title: "Mobile Application",
    description:
      "Extend your product into dedicated Android and iOS experiences.",
  },
  {
    icon: Boxes,
    title: "Complete Digital Product",
    description:
      "Combine product strategy, requirements, web application and mobile application development into one solution.",
  },
];

export default function Solutions() {
  return (
    <section
      id="solutions"
      data-testid="solutions-section"
      className="py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Eyebrow>Solutions</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            Need more than documentation?
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-navy/70">
            Beyond requirements and product documentation, Kaizen Labs can
            support your business through design, build and delivery.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <article
                data-testid={`solution-card-${i}`}
                className="group flex h-full flex-col border border-navy/15 bg-white p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-navy/40"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/15 bg-cream text-navy transition-colors duration-300 group-hover:border-rust group-hover:bg-rust group-hover:text-white">
                  <s.icon className="h-5 w-5" strokeWidth={1.5} />
                </span>
                <h3 className="mt-7 font-display text-2xl font-medium leading-snug tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-navy/70">
                  {s.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div className="mt-14">
            <a
              href="#contact"
              data-testid="solutions-discuss-product-btn"
              className="inline-flex items-center rounded-full bg-navy px-8 py-3.5 text-sm font-medium text-cream transition-transform duration-300 hover:-translate-y-0.5"
            >
              Discuss Your Product
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
